import { useEffect, useEffectEvent } from "react";

import { getRootDispatcher } from "@/analytics";
import { useLogger, useSessionId } from "@/sdk";
import { usePartner } from "@/sdk/agent/hooks/usePartner";

import { getProductOffer } from "../api/getProductOffer";
import { type EligibleProduct, useProductOfferStore } from "../stores";
import { updatePrimaryProductSaleProgress } from "../utils/updatePrimaryProductSaleProgress";

export const useQuerySelectedProductOffer = () => {
    const logger = useLogger({ module: "useQuerySelectedProductOffer", supportTeam: "sales" });
    const partner = usePartner();
    const sessionId = useSessionId();
    const selectedProduct = useProductOfferStore((state) => state.getSelectedProduct(sessionId));

    const onUpdate = useEffectEvent(async (selectedProduct: EligibleProduct) => {
        try {
            const { enrollmentStatus } = await getProductOffer(
                logger,
                selectedProduct.id,
                partner,
                selectedProduct.salesProvider,
            );

            if (enrollmentStatus == null) {
                return;
            }

            updatePrimaryProductSaleProgress({
                offerId: selectedProduct.id,
                status: enrollmentStatus,
                salesProvider: selectedProduct.salesProvider,
            });
        } catch (error) {
            void getRootDispatcher().dispatchBusinessEvent("GetProductOfferError", {
                productOfferId: selectedProduct.id,
                partner,
                error,
            });
        }
    });

    useEffect(() => {
        if (selectedProduct == null) {
            return; // no active product
        }

        void onUpdate(selectedProduct);
    }, [partner, selectedProduct]);
};
